export class CanMarshal<T> {
	constructor(propsObj?: T) {
		Object.assign(this, propsObj);
	}
}